import { render, staticRenderFns } from "./BroadcastPublisherUnassignMessage.vue?vue&type=template&id=17b39f98&scoped=true&"
import script from "./BroadcastPublisherUnassignMessage.vue?vue&type=script&lang=js&"
export * from "./BroadcastPublisherUnassignMessage.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastPublisherUnassignMessage.vue?vue&type=style&index=0&id=17b39f98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b39f98",
  null
  
)

export default component.exports